module.exports = __webpack_public_path__ + "img/linode.3cb89426.svg";